import { Link } from "react-router-dom";
import { ArrowUpRight, Briefcase } from "lucide-react";

/** Life after the playing career: the current role, the work, and any judgment attached to it. */
export const AfterFootball = ({ data }) =>
  data ? (
    <section className="mt-10 border-l-2 border-ochre bg-[#0b0b0b] p-6 md:p-8" data-testid="after-football">
      <div className="flex items-center gap-2">
        <Briefcase size={14} className="text-ochre" />
        <p className="overline text-ochre">After football</p>
      </div>
      <h3 className="mt-4 max-w-3xl font-display text-xl font-bold uppercase leading-tight text-white md:text-2xl">
        {data.role}
      </h3>
      <p className="mt-5 max-w-3xl text-sm leading-relaxed text-zinc-300 md:text-base">{data.body}</p>

      {data.case ? (
        <Link
          to={data.case.to}
          data-testid="after-football-case"
          className="group mt-6 block border border-zinc-800 p-5 transition-colors hover:border-ochre"
        >
          <p className="mono text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500">Judicial review</p>
          <p className="mt-2 text-sm font-semibold leading-snug text-white group-hover:text-ochre">
            {data.case.title}
          </p>
          <p className="mono mt-2 text-[0.56rem] uppercase leading-relaxed tracking-[0.14em] text-ochre">
            {data.case.citation}
          </p>
          <span className="mono mt-3 inline-flex items-center gap-1.5 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-400 group-hover:text-ochre">
            Read it in Sports Law <ArrowUpRight size={11} />
          </span>
        </Link>
      ) : null}

      {data.logos?.length ? (
        <div className="mt-7 flex flex-wrap items-center gap-4" data-testid="after-football-logos">
          {data.logos.map((l) => (
            <a
              key={l.url}
              href={l.url}
              target="_blank"
              rel="noreferrer"
              title={l.name}
              aria-label={l.name}
              data-testid={`after-football-logo-${l.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="group flex cursor-pointer items-center gap-3 border border-zinc-800 bg-black px-4 py-3 transition-colors hover:border-ochre"
            >
              <img
                src={l.image}
                alt={`${l.name} logo`}
                loading="lazy"
                className="h-10 w-10 object-contain"
              />
              <span className="mono text-[0.55rem] uppercase leading-relaxed tracking-[0.16em] text-zinc-400 transition-colors group-hover:text-ochre">
                {l.name}
              </span>
              <ArrowUpRight size={11} className="text-zinc-600 transition-colors group-hover:text-ochre" />
            </a>
          ))}
        </div>
      ) : null}

      {data.sources?.length ? (
        <div className="mt-6 flex flex-col gap-2" data-testid="after-football-sources">
          {data.sources.map((s) => (
            <a
              key={s.url}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              className="mono inline-flex items-center gap-2 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500 transition-colors hover:text-ochre"
            >
              {s.label} <ArrowUpRight size={11} />
            </a>
          ))}        </div>
      ) : null}

      {data.videos?.length ? (
        <div className="mt-7 grid gap-6 md:grid-cols-2" data-testid="after-football-videos">
          {data.videos.map((v) => (
            <div key={v.id} data-testid={`after-football-video-${v.id}`}>
              <div className="relative w-full border border-zinc-800" style={{ paddingBottom: "56.25%" }}>
                <iframe
                  src={`https://www.youtube.com/embed/${v.id}`}
                  title={v.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                  className="absolute inset-0 h-full w-full"
                />
              </div>
              <p className="mono mt-3 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500">{v.title}</p>
            </div>
          ))}
        </div>
      ) : null}
    </section>
  ) : null;
